package uz.ferro.erp.feature.task.data

import kotlinx.coroutines.delay
import uz.ferro.erp.api.suspendPost
import uz.ferro.erp.feature.task.model.ExcelToTaskResult
import uz.ferro.erp.feature.task.model.dto.TaskDto
import uz.ferro.erp.feature.task.model.dto.TaskFilterDto
import web.file.File
import web.form.FormData

object TaskRepository {

    suspend fun getTasks(filter: TaskFilterDto): List<TaskDto> {
        return suspendPost("task/find", body = filter)
    }

    suspend fun importFromExcel(file: File): ExcelToTaskResult {
        val formData = FormData()
        formData.append("file", file)
        return suspendPost(path = "task/import", body = formData)
    }

    suspend fun addTasksBatch(tasks: List<TaskDto>): List<TaskDto> {
        delay(3000)
        return suspendPost(path = "task/batch", body = tasks)
    }
}